import { all, call, put, takeLatest } from 'redux-saga/effects';

import * as errorHandlerActions from '@/components/errorHandler/Actions';
import { ROUTES_API } from '@/services/Constants';
import { processRequest } from '@/services/Api';
import * as wrappedActions from '../store/actions';
import { CHAPTER_ORDER, wrappedActionTypes } from '../store/constants';
import { WrappedChapter } from '../types';

export default function* (): Generator {
	yield all([
		takeLatest(wrappedActionTypes.GET_YEAR_SUMMARY_REQUEST, handleGetYearSummaryRequest),
	]);
}

export function* handleGetYearSummaryRequest() {
	try {
		const { data } = yield call(processRequest, ROUTES_API.YEAR_SUMMARY);

		// Filter out chapters that have null data and create ChapterItem objects
		const availableChapters = CHAPTER_ORDER.filter((chapter: WrappedChapter) => {
			const chapterData = data[chapter];
			return chapterData !== null && chapterData !== undefined;
		}).map((chapter: WrappedChapter) => ({
			type: chapter,
			data: data[chapter],
		}));

		yield put(wrappedActions.getYearSummarySuccess(availableChapters));
	} catch (e: any) {
		yield put(errorHandlerActions.handleError(e, 'page-blocking'));
		yield put(wrappedActions.getYearSummaryError(e.message));
	}
}
